import Alpine from "alpinejs";
import * as rebuy from "../api/rebuy";

Alpine.store("rebuy", {
  getProductsFromRuleset(rulesetId) {
    return rebuy.getProductsFromRuleset(rulesetId);
  },
});


Alpine.data('rebuyCarousel', (rulesetId) => {

  const fetchProducts = async () => {
    let products = []

    const rebuyResponse = await Alpine.store('rebuy').getProductsFromRuleset(rulesetId)
    if (!rebuyResponse.data) {
      console.error('Invalid response from Rebuy: ', rebuyResponse.error)
      return
    }

    products = rebuyResponse.data

    const shopifyPromises = rebuyResponse.data.map(async (product) => {
      const shopifyResponse = await Alpine.store('main').graphQl(`
        {
          product(id: "${product.admin_graphql_api_id}") {
            tea_type: metafield(key: "tea_type", namespace: "my_fields") {
              value
            }
            tasting_notes: metafield(key: "tasting_notes", namespace: "my_fields") {
              value
            }
            list_hover_image: metafield(key: "list_hover_image", namespace: "custom") {
              reference {
                ... on MediaImage {
                  image {
                    height
                    altText
                    width
                    url(transform: {maxWidth: 800})
                  }
                }
              }
            }
            list_badge: metafield(key: "list_badge", namespace: "custom") {
              reference {
                ... on MediaImage {
                  image {
                    height
                    altText
                    width
                    url(transform: {maxWidth: 200})
                  }
                }
              }
            }
            priceRange {
              maxVariantPrice {
                amount
              }
              minVariantPrice {
                amount
              }
            }
          }
        }
      `)

      if (shopifyResponse?.data?.product) {
        product.priceRange = shopifyResponse.data.product.priceRange
        if (shopifyResponse.data.product.tea_type.value) {
          product.tea_type = JSON.parse(shopifyResponse.data.product.tea_type.value)
        }
        product.list_hover_image = shopifyResponse.data.product.list_hover_image
        product.list_badge = shopifyResponse.data.product.list_badge
        product.tasting_notes = shopifyResponse.data.product.tasting_notes?.value
      } else {
        console.error('Invalid Shopify GraphQl response', shopifyResponse.errors)
      }
    })

    await Promise.all(shopifyPromises)

    return products
  }

  return {
    init() {
      fetchProducts().then((products) => {
        this.products = products

        products.forEach((product) => {
          product.productCardVariants = []
          product.lowestPrice = null
          product.options = product.options.filter((option) => option.name.toLowerCase() != 'title')

          product.priceRange.minVariantPrice.amount = Math.round(parseFloat(product.priceRange.minVariantPrice.amount) * 100)
          product.priceRange.maxVariantPrice.amount = Math.round(parseFloat(product.priceRange.maxVariantPrice.amount) * 100)

          product.variants.forEach((variant) => {
            const variantPrice = Math.round(parseFloat(variant.price) * 100);

            if (variant.title?.toLowerCase() != 'teaser' && (product.lowestPrice == null || product.lowestPrice > variantPrice)) {
              product.lowestPrice = variantPrice
            }

            product.productCardVariants.push({
              id: variant.id,
              variantPrice,
              optionValues: [
                variant.option1,
                variant.option2,
                variant.option3,
              ],
              isAvailable: true,
            })
          })
        })
      })
    },
    products: null,
    fadeIn: false
  }
})
